import { css } from "@stubhub/broadway-foundation/css";

export const mobileCredibilityBadgeBelowHero = css({
  paddingInline: "primitives.150",
  paddingBlockEnd: "primitives.100",
});

export const mobileCredibilityBadgeBelowHeroLabel = css({
  display: "flex",
  width: "full",
  height: "[22px]",
  minHeight: "[22px]",
  paddingBlock: "primitives.25",
  paddingInlineStart: "primitives.25",
  paddingInlineEnd: "[10px]",
  justifyContent: "center",
  alignItems: "center",
  rowGap: "primitives.75",
  columnGap: "primitives.75",
  borderStartRadius: "element.extraSmall",
  borderEndRadius: "element.extraSmall",
});

export const HeaderAndBannerContainer = css({
  display: "flex",
  flexDirection: "column",
  height: "auto",
  backgroundColor: "bg",
});
